import { defineComponent } from 'vue';
export default defineComponent({
  name: 'PrequalDisclaimers',
  emits: ['showDisclosure'],
  methods: {
    showThisDisclosure(name) {
      this.$emit('showDisclosure', name);
    }
  }
});